export function LogIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M17.1312 7.94348C17.4824 7.591 18.0538 7.59062 18.4056 7.9425C18.7563 8.29341 18.7567 8.86242 18.4066 9.21399L13.6215 14.0197C13.5814 14.0599 13.5355 14.0948 13.4857 14.1222L12.4193 14.7101C11.999 14.9417 11.5257 14.5055 11.722 14.0675L12.2406 12.9113C12.2703 12.8451 12.3115 12.7849 12.3627 12.7335L17.1312 7.94348Z" fill="currentColor" stroke="currentColor" stroke-width="0.2" />
      <path d="M17 6.5V4C17 2.89543 16.1046 2 15 2H5C3.89543 2 3 2.89543 3 4V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V12.5" stroke="currentColor" stroke-width="1.67" />
      <path d="M8.66667 11.3334L7 11.3334M12 8.00004L7 8.00004" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "LogIcon";
